import { IValidationEventMessage } from "../models/IntegrationModel";

export class Viol3ValidationEventMessage {
    $type: string;
    validationMessages: IValidationEventMessage[];
    arbetsorderId: number;
    // eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "Viol3ValidationEventMessage";
    constructor() {
        this.$type =  Viol3ValidationEventMessage.$type;
    }
}
